module.exports = "/_next/static/images/68f5782cd9230cfc3ca39c07d2cb6af9-vigilado-xl.png.webp";